import { ChartJsDoughnut } from "./base";

const Donut: typeof ChartJsDoughnut = ({ data, ...props }) => (
  <ChartJsDoughnut data={data} {...props} />
);

export default Donut;
